<template lang="pug">
div(v-if="visible && enabled")
  walleto-blocking-warning-modal(ref="agreementNotice" @modal-canceled="onModalCanceled" @modal-ok="onModalOk")
  div.alert.alert-warning
    .alert__grid
      div
        p {{$t('message')}}
      div
        button(@click.prevent="showModal" :disabled="busy").btn.btn-success.btn-sm.btn__grid
          div
            span {{$t('Подать заявление')}}
          div(v-if="busy" style="padding-left: 10px;")
            circle-loader( size="15px" :no-title="true")

</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import WalletoBlockingWarningModal
  from "@/views/pages/global/notices/walleto/WalletoBlockingWarningModal.vue";
import {RemoteRequestState} from "@/backoffice/components/pages/taxrules/taxrules";
import CircleLoader from "@/components/loaders/CircleLoader.vue";



@Component({
  name: "WalletoRefundAlert",
  components: {CircleLoader, WalletoBlockingWarningModal}
})
export default class WalletoRefundAlert extends Vue{
  @Prop({default: true})
  enabled: boolean


  visible = true;
  openStatus = new RemoteRequestState();

  get busy() {
    return this.openStatus.isLoading;
  }

  onModalCanceled() {
    this.openStatus.loadEnd();
    return null;
  }

  onModalOk() {
    this.openStatus.loadEnd();
    this.visible = false;
  }

  showModal() {
    this.openStatus.loadStart();
    (this.$refs.agreementNotice as WalletoBlockingWarningModal).openAgreementMode();
  }
}
</script>

<style scoped lang="less">
.alert__grid {
  display: grid;
  grid-gap: 20px;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: auto min-content;
  p {
    margin: 0; padding: 0;
  }
  .btn__grid {
    grid-auto-columns: auto;
    display: grid;
    grid-gap: 0;
    align-items: center;
    grid-auto-flow: column;
    justify-content: center;
    grid-template-columns: auto;
  }
}
</style>

<i18n>
{
  "en": {
    "message": "Submit an application for a refund from your blocked VISA cards.",
    "Подать заявление": "Submit the application"
  },
  "ru": {
    "message": "Оформите заявление на возврат средств с ваших заблокированных карт VISA."
  }
}
</i18n>
